import profile from "../../assets/img/profile-1.png";
import { ReviewIcon } from "./Icons";

const HappyClientsCard = ({ obj }) => {
  return (
    <div className="sm:py-10 py-5 px-3 w-full">
      <div className="bg-[#FAFAFA] sm:p-8 p-5 w-full border border-[#1E1E1E1A] hover:border-white rounded-[12px] hover:bg-white hover:shadow-[0px_8px_20px_0px_#00594C1F] transition-all duration-300">
        <ReviewIcon />
        <p className="text-base max-sm:text-sm font-normal text-[#363636] py-5">
          Lorem Ipsum has been the industry's standard dummy text ever since the
          1500s, when an unknown printer took a galley of type and scrambled
        </p>
        <div className="flex gap-3 items-center">
          <img className="w-full max-w-[48px]" src={profile} alt="profile" />
          <div>
            <p className="text-base max-sm:text-sm font-semibold text-[#019FDB]">
              Liana
            </p>
            <p className="text-xs max-sm:text-sm font-normal pt-1">
              CEO Design
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HappyClientsCard;
